<template>
	<v-container grid-list-md>
		<v-card flat>
			<v-card-title primary-title>
				<v-btn icon @click="
					back()
				">
					<v-icon>mdi-arrow-left</v-icon>
				</v-btn>
				<strong>{{ $t("title.show_order") }}</strong>
			</v-card-title>
			<h2 class="pl-5">
				Thank you, your order #{{ order.code }} has been placed
				successfully!
			</h2>
			<v-card-subtitle class="pt-5 pb-10">
				<GmapMap :center="{ lat: latitude, lng: longitude }" :zoom="15" map-type-id="terrain"
					style="width: 100%; height: 400px" ref="mapRef" :options="{
						styles: mapStyles,
					}">
					<GmapMarker v-if="order.address" :position="{
						lat: order.address.latitude,
						lng: order.address.longitude,
					}" :clickable="true" :draggable="false" :title="order.address.name" :optimized="false"
						:icon="order.address.icon_url" />
					<GmapMarker v-if="order.outlet" :position="{
						lat: order.outlet.latitude,
						lng: order.outlet.longitude,
					}" :clickable="true" :draggable="false" :title="order.outlet.name" :optimized="false"
						:icon="order.outlet.icon_url" />
				</GmapMap>
			</v-card-subtitle>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md8>
						<v-layout row wrap>
							<v-flex xs12 md6>
								<v-subheader><strong>{{
								$t("label.detail")
								}}</strong></v-subheader>
								<table style="width: 100%">
									<tbody>
										<tr>
											<td>{{ $t("Outlet") }}</td>
											<td>
												<strong>
													{{
													order.outlet
													? order.outlet.name
													: "N/A"
													}}
												</strong>
											</td>
										</tr>
										<tr>
											<td>{{ $t("Date") }}</td>
											<td>
												<strong>{{
												order.date
												}}</strong>
											</td>
										</tr>
										<tr>
											<td>{{ $t("Time") }}</td>
											<td>
												<strong>{{
												order.time
												}}</strong>
											</td>
										</tr>
										<tr>
											<td>Payment method Code</td>
											<td>
												<strong>{{
												order.payment_method_code
												}}</strong>
											</td>
										</tr>
									</tbody>
								</table>
							</v-flex>
							<v-flex xs12>
								<v-subheader><strong>{{
								$t("label.items")
								}}</strong></v-subheader>
								<v-simple-table class="elevation-1">
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left">#</th>
												<th class="text-left">
													Product
												</th>
												<th class="text-left">
													{{ $t("label.quantity") }}
												</th>
												<th class="text-left">Price</th>
												<th class="text-left">
													{{ $t("Subtotal") }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(
													line, index
												) in order.items" :key="index">
												<td>
													{{ index + 1 }}
												</td>
												<td>
													{{ line.product_name }}
												</td>
												<td>{{ line.quantity }}</td>
												<td>
													{{ line.price | currency }}
												</td>
												<td>
													{{
													(line.quantity *
													line.price)
													| currency
													}}
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td colspan="3">&nbsp;</td>
												<td class="text-right">
													<strong>
														{{
														$t("Total")
														}}</strong>
												</td>
												<td>
													<strong>{{
													order.total | currency
													}}</strong>
												</td>
											</tr>
										</tfoot>
									</template>
								</v-simple-table>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md4>
						<v-subheader>
							<strong>{{ $t("label.transactions") }}</strong>
						</v-subheader>
						<OrderTransactions :transactions="transactions"></OrderTransactions>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import OrderTransactions from "@Shop/components/OrderTransactions.vue";
export default {
	components: {
		OrderTransactions,
	},

	props: ["order", "transactions"],

	computed: {
		latitude() {
			return this.order && this.order.address
				? this.order.address.latitude
				: 11.5564;
		},
		longitude() {
			return this.order && this.order.address
				? this.order.address.longitude
				: 104.9282;
		},

		mapStyles() {
			return [
				{
					featureType: "administrative",
					elementType: "geometry",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.land_parcel",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.neighborhood",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "poi",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road",
					elementType: "labels",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road",
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "transit",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "water",
					elementType: "labels.text",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
			];
		},
	},

	methods: {
		back() {
			window.history.back();
		}
	}
};
</script>